var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"opacity":".528","fillRule":"evenodd","clipRule":"evenodd","d":"M3.968 3.455L.618.106A.362.362 0 00.107.62l3.331 3.33-3.33 3.332a.362.362 0 10.512.512l3.349-3.349 3.35 3.35a.362.362 0 00.512-.513L4.499 3.95 7.829.619a.362.362 0 10-.512-.513l-3.349 3.35z","fill":"#333"}));
}

Close.defaultProps = {"width":"8","height":"8","fill":"none"};

module.exports = Close;

Close.default = Close;
